import createAuth0Client from '@auth0/auth0-spa-js';

export default class AuthService {
  constructor(config) {
    this.config = config;
    this.auth0Client = null;
    this.initClient().then();
  }

  async initClient() {
    try {
      if (!this.auth0Client) {
        // WARNING: createAuth0Client seems to fail silently, doesn't throw error
        this.auth0Client = await createAuth0Client({
          domain: "dev-7urjfmg0.us.auth0.com",
          client_id: "2F3JjQd63HO3BEFqho0kxgUPzBTiAazH",
          redirect_uri: `${window.location.origin}/ssosuccess`,
          useRefreshTokens: true,
          cacheLocation: 'localstorage',
          audience: "https://www.aspenify.com/api"
        });
      }
    } catch (e) {
      console.error(e)
      alert('Auth0 failed to initiate')
    }
  }

  async login() {
    await this.initClient()
    await this.auth0Client.loginWithRedirect({
      connection: this.config.connectionName
    })
  }
  
  async handleCallback() {
    await this.initClient()
    return await this.auth0Client.handleRedirectCallback()
  }
  
  async getToken() {
    await this.initClient();

    const token = await this.auth0Client.getTokenSilently({
      audience: "https://www.aspenify.com/api", 
      ignoreCache: false,
    })
    return token
  }
  
  async getUser(params) {
    await this.initClient();
    const user = await this.auth0Client.getUser(params)
    return user
  }
  
  async logout() {
    await this.initClient();
    if (this.auth0Client) {
      await this.auth0Client.logout({
          returnTo: `${window.location.origin}/login`,
        })
    }
  }
}